import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BankOutlinedSvg from "@ant-design/icons-svg/es/asn/BankOutlined";
import AntdIcon from '../components/AntdIcon';
var BankOutlined = function BankOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BankOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BankOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BankOutlined';
}
export default RefIcon;